import { render } from "./PairScan.vue?vue&type=template&id=04d1bcf0&scoped=true"
import script from "./PairScan.vue?vue&type=script&lang=ts"
export * from "./PairScan.vue?vue&type=script&lang=ts"

import "./PairScan.vue?vue&type=style&index=0&id=04d1bcf0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04d1bcf0"

export default script